/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable comma-dangle */
import PropTypes from 'prop-types';
import './App.css';
import './index.css';
import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { animateScroll as scroller } from 'react-scroll';
import {
  BrowserRouter, Routes, Route,
} from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import TitlePage from './components/TitlePage/TitlePage';
import Download from './components/Download/Download.tsx';
import About from './components/About/About';

import UserPage from './pages/UserPage';
import Footer from './components/Footer/Footer';
import Password from './components/Password/Password';
import MonsterWalkPassword from './components/MonsterWalkPassword/MonsterWalkPassword';

function App(props) {
  const {
    updateUserData,
    setPlayerVerified
  } = props;

  const [showModal, setShowModal] = useState(false);

  function showLogin() {
    setShowModal(true);
  }
  function closeLogin() {
    setShowModal(false);
  }

  return (
    <div className="App">
      {isBrowser && (
      <>
        <TalofaNavbar showLogin={showLogin} />
        <TitlePage
          closeLogin={closeLogin}
          showLogin={showModal}
          updateUserData={updateUserData}
          setPlayerVerified={setPlayerVerified}
        />
        <Download />
        <About />
        <Footer />
      </>
      )}
      {!isBrowser && (
      <>
        {' '}
        <img className="logo_mobile" src="./logoTransparent.png" alt="" />
        <h1 className="text_mobile">Please load this website using a desktop</h1>
      </>
      )}
    </div>
  );
}

App.propTypes = {
  updateUserData: PropTypes.func.isRequired,
  setPlayerVerified: PropTypes.func.isRequired
};

function TalofaNavbar(props) {
  const scrollToDiv = (name) => {
    scroller.scrollTo(name, {
      duration: 1500,
      smooth: 'easeInOutQuint',
    });
  };
  return (
    <div className="navbar">
      <Navbar collapseOnSelect bg="dark" expand="lg" variant="dark">
        <Navbar.Brand href="#home">
          <Nav.Link href="#" onClick={() => scrollToDiv('titleSection')}>
            <picture>
              {/* <source srcSet="./logoTransparent.jpeg" type="image/webp" />
              <source srcSet="./logoTransparent.jpeg" type="image/jpeg" /> */}
              <img className="talofa_logo" src="./logoTransparent.png" alt="" />
            </picture>
          </Nav.Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto" />
          <Nav>
            <Nav.Link target="_blank" href="https://www.talofagames.com/faq/bullshark">
              FAQ
            </Nav.Link>
            <Nav.Link onClick={() => props.showLogin()} target="_blank">
              Login
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

function AppWrapper() {
  const [userData, setUserData] = useState(false);
  const [playerVerified, setPlayerVerified] = useState(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App updateUserData={setUserData} setPlayerVerified={setPlayerVerified} />} />
        <Route path="/userPage" element={<UserPage userData={userData} playerVerified={playerVerified} setPlayerVerified={setPlayerVerified} />} />
        <Route path="/password-recovery" element={<Password />} />
        <Route path="/monsterwalk-password-recovery" element={<MonsterWalkPassword />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppWrapper;
